<template>
    <div id="ad" >
      <div id="div1" :class="{hiddenBox: isShow}">
        <div id="d1">
          <a href="#"></a>
        </div>
        <span @click="closeAd">X</span>
      </div>
      <div id="div2" :class="{hiddenBox: isShow2}">
        <div id="d2">
          <a href="#"></a>
        </div>
        <span @click="closeAd2">X</span>
      </div>
    </div>
  </template>
  
  <script>
  import {apiService, RESULT_CODE} from "@/api/ApiService.js"
  export default {
    name: "Ad",
    props: [],
    data() {
      return {
        isShow: true,
        isShow2: true
      };
    },
    mounted: function () {
  
              
              let that = this
  
              apiService.findShowAd().then(res => {
              
                      let adList = res.data
                      
                      
                      if (adList && adList.length===1) {
                          //获取元素
                          document.querySelector('#div1>#d1>a').style.backgroundImage = 'url("'+adList[0].adImg         +'")'
                          document.querySelector('#div1>#d1>a').href = '/#/ArticleInit/detail?articleId='+adList[0].linkArticleId
                          var div1 = document.getElementById('div1');
                          var w = document.documentElement.clientWidth;
                          var h = document.documentElement.clientHeight;
                          var gox = 1;
                          var goy = 1;
                          var a=0;
                          //广告漂浮
                          function move() {
                              var x = div1.offsetLeft;
                              var y = div1.offsetTop;
                              
                              
                              if (x >= w - 250 || x <= 0) gox = -gox;
                              let xMove = x + (1 * gox) 
                              if (xMove > w) {
                                xMove = w
                              } else if (xMove < 0) {
                                xMove = 0
                              }
                              div1.style.left = xMove + 'px';
                              if (y >= h - 150 || y <= 0) goy = -goy;
                              let yMove = y + (1 * goy) 
                              if (yMove > h) {
                                yMove = h
                              } else if (yMove < 0) {
                                yMove = 0
                              }
                              div1.style.top = yMove + 'px';
                          }
                          //漂浮定时器
                          var timer = setInterval(move, 10);
                          //移入移出时广告的浮动
                          div1.onmouseover = function () {
                              clearInterval(timer);
                          }
                          div1.onmouseout = function () {
                              timer = setInterval(move, 10);
                          }
                          that.isShow = false;
                          
                      } else if (adList && adList.length>1) {
                      
                      
                          document.querySelector('#div1>#d1>a').style.backgroundImage = 'url("'+adList[0].adImg+'")'
                          document.querySelector('#div1>#d1>a').href = '/#/ArticleInit/detail?articleId='+adList[0].linkArticleId
                          
                          document.querySelector('#div2>#d2>a').style.backgroundImage = 'url("'+adList[1].adImg+'")'
                          document.querySelector('#div2>#d2>a').href = '/#/ArticleInit/detail?articleId='+adList[1].linkArticleId
                          //获取元素
                          var div1 = document.getElementById('div1');
                          var div2 = document.getElementById('div2');
                          var w = document.documentElement.clientWidth;
                          var h = document.documentElement.clientHeight;
                          var gox = 1;
                          var goy = 1;
                          var a=0;
                          //广告漂浮
                          function move() {
                              var x = div1.offsetLeft;
                              var y = div1.offsetTop;
                              
                              
                              //if (x >= w - 250 || x <= 0) ;
                              let xMove = x + (1 * gox) 
                              if (xMove > w) {
                                xMove = w
                              } else if (xMove < 0) {
                                xMove = 0
                              }
                              div1.style.left = xMove + 'px';
                              if (y >= h - 150 || y <= 0) {goy = -goy;gox = -gox}
                              let yMove = y + (1 * goy) 
                              if (yMove > h) {
                                yMove = h
                              } else if (yMove < 0) {
                                yMove = 0
                              }
                              div1.style.top = yMove + 'px';
                          }
                          //漂浮定时器
                          var timer = setInterval(move, 10);
                          //移入移出时广告的浮动
                          div1.onmouseover = function () {
                              clearInterval(timer);
                          }
                          div1.onmouseout = function () {
                              timer = setInterval(move, 10);
                          }
                          
                          var gox2 = -1;
                          var goy2 = 1;
                          function move2() {
                              var x = div2.offsetLeft;
                              var y = div2.offsetTop;
                              
                              
                              //if (x >= w - 250 || x <= 0) ;
                              let xMove = x + (1 * gox2) 
                              if (xMove > w) {
                                xMove = w
                              } else if (xMove < 0) {
                                xMove = 0
                              }
                              div2.style.left = xMove + 'px';
                              if (y >= h - 150 || y <= 0) {goy2 = -goy2;gox2 = -gox2}
                              let yMove = y + (1 * goy2) 
                              if (yMove > h) {
                                yMove = h
                              } else if (yMove < 0) {
                                yMove = 0
                              }
                              div2.style.top = yMove + 'px';
                          }
                          //漂浮定时器
                          var timer2 = setInterval(move2, 10);
                          //移入移出时广告的浮动
                          div2.onmouseover = function () {
                              clearInterval(timer2);
                          }
                          div2.onmouseout = function () {
                              timer2 = setInterval(move2, 10);
                          }
                          that.isShow = false;
                          that.isShow2 = false;
                      }
                      
              
              })
              
  
  
  
  
  
  
    },
    methods: {
      closeAd () {
        this.isShow = !this.isShow
      },
      closeAd2 () {
        this.isShow2 = !this.isShow2
      },
      
    }
  };
  </script>
  
  <style scoped>
      @media screen and (min-width: 481px) {
       
       
        
        #div1 {
              width: 250px;
              height: 150px;
              padding: 0;
              margin: 0;
              position: fixed;
              left: 0;
              top: 0;
              background-position: center;
              z-index: 999999;
          }
          #div2 {
              width: 250px;
              height: 150px;
              padding: 0;
              margin: 0;
              position: fixed;
              right: 0;
              top: 0;
              background-position: center;
              z-index: 999999;
          }
          #div1>div,#div2>div {
              height: 100%;
          }
          #div1 a,#div2 a {
              background-position: center;
              background-size: cover;
              width: 100%;
              height: 100%;
              display: block;
          }
          
          #div1>span,#div2>span {
            position: absolute;
            top: 5px;
            right: 5px;
            font-weight: 700;
            font-size: 14px;
            cursor: pointer;
          }
          .hiddenBox {
            display: none;
          }
      }
      @media screen and (max-width: 480px)  {
         #div1,#div2 {
          display: none;
        }
      }
  
      
  </style>
  


// WEBPACK FOOTER //
// src/components/Ad.vue